import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const restaurantsStore = {
    actionCreators,
    reducer,
};

export default restaurantsStore;
